module.exports = __webpack_public_path__ + "static/img/xungengdian.f2373d51.png";